<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card elevation="3" class="rounded-lg overflow-hidden">
          <v-card-title class="bg-primary text-white text-h5 font-weight-bold py-4 d-flex justify-space-between align-center">
            <div>
              <v-icon class="mr-2 mb-1">mdi-store</v-icon>
              {{ sport_store.store_name }}
            </div>
            <v-btn v-if="is_logged_in" icon @click="toggleFavorite" variant="text" color="white">
              <v-icon :color="is_favorite ? 'yellow' : 'white'" size="large">
                {{ is_favorite ? 'mdi-heart' : 'mdi-heart-outline' }}
              </v-icon>
            </v-btn>
          </v-card-title>
          
          <v-card-subtitle class="pt-4 text-subtitle-1 font-weight-medium" style="white-space: pre-wrap;">
            {{ sport_store.appeal_point }}
          </v-card-subtitle>

          <!-- 競技タグ -->
          <v-card-text v-if="selectSportsGearValues.length > 0" class="pb-1 mt-2">
            <v-chip
              v-for="(gear, index) in selectSportsGearValues"
              :key="index"
              class="mr-2 mb-2"
              color="secondary"
              variant="flat"
            >
              <v-icon start icon="mdi-run"></v-icon>
              {{ getSportName(gear) }}
            </v-chip>
          </v-card-text>

          <v-tabs v-model="tab" color="primary" class="mt-2" align-tabs="center" grow>
            <v-tab value="1">
              <v-icon start>mdi-information</v-icon>
              店舗情報
            </v-tab>
            <v-tab value="2">
              <v-icon start>mdi-comment-text-multiple</v-icon>
              クチコミ・Ｑ＆Ａ
            </v-tab>
            <v-tab value="3">
              <v-icon start>mdi-map-marker</v-icon>
              アクセス
            </v-tab>
          </v-tabs>

          <v-divider></v-divider>

          <v-card-text class="pa-0 bg-grey-lighten-4">
            <v-window v-model="tab">
              <!-- 店舗情報 タブ -->
              <v-window-item value="1">
                <div v-if="uploadFileList.length > 0">
                  <v-carousel height="350" :show-arrows="uploadFileList.length > 1" hide-delimiter-background cycle>
                    <v-carousel-item v-for="(file, index) in uploadFileList" :key="index" :src="file.url" cover>
                    </v-carousel-item>
                  </v-carousel>
                </div>

                <v-list lines="two" class="bg-white ma-4 rounded-lg elevation-1">
                  <v-list-item>
                    <template v-slot:prepend>
                      <v-icon color="primary" class="mr-3">mdi-phone</v-icon>
                    </template>
                    <v-list-item-title class="font-weight-bold">電話番号</v-list-item-title>
                    <v-list-item-subtitle class="mt-1">{{ sport_store.phone_number || '未登録' }}</v-list-item-subtitle>
                  </v-list-item>

                  <v-divider inset></v-divider>

                  <v-list-item>
                    <template v-slot:prepend>
                      <v-icon color="primary" class="mr-3">mdi-clock-outline</v-icon>
                    </template>
                    <v-list-item-title class="font-weight-bold">営業時間</v-list-item-title>
                    <v-list-item-subtitle class="mt-1">{{ sport_store.business_hours || '未登録' }}</v-list-item-subtitle>
                  </v-list-item>

                  <v-divider inset></v-divider>

                  <v-list-item>
                    <template v-slot:prepend>
                      <v-icon color="primary" class="mr-3">mdi-calendar-remove</v-icon>
                    </template>
                    <v-list-item-title class="font-weight-bold">定休日</v-list-item-title>
                    <v-list-item-subtitle class="mt-1">{{ sport_store.regular_holiday || '未登録' }}</v-list-item-subtitle>
                  </v-list-item>

                  <v-divider inset></v-divider>

                  <v-list-item>
                    <template v-slot:prepend>
                      <v-icon color="primary" class="mr-3">mdi-car</v-icon>
                    </template>
                    <v-list-item-title class="font-weight-bold">駐車場</v-list-item-title>
                    <v-list-item-subtitle class="mt-1">
                      <v-chip v-if="sport_store.parking_lot_availability" color="success" size="small" variant="flat">あり</v-chip>
                      <v-chip v-else color="grey" size="small" variant="flat">なし</v-chip>
                    </v-list-item-subtitle>
                  </v-list-item>

                  <template v-if="linkList.length > 0">
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <template v-slot:prepend>
                        <v-icon color="primary" class="mr-3">mdi-link</v-icon>
                      </template>
                      <v-list-item-title class="font-weight-bold">リンク</v-list-item-title>
                      <v-list-item-subtitle class="mt-1">
                        <div v-for="(link, index) in linkList" :key="index" class="mb-1">
                          <a :href="link.path" target="_blank" class="text-decoration-none text-primary">
                            <v-icon size="small" class="mr-1">mdi-open-in-new</v-icon>
                            {{ link.path }}
                          </a>
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>
                </v-list>
              </v-window-item>

              <!-- クチコミ タブ -->
              <v-window-item value="2">
                <v-card-text class="bg-white ma-4 rounded-lg elevation-1 min-h-200">
                  <div v-if="sport_store.sports_store_inquiry && sport_store.sports_store_inquiry.length > 0">
                    <v-list lines="three">
                      <v-list-item v-for="(inquiry, index) in sport_store.sports_store_inquiry" :key="index" class="mb-4">
                        <template v-slot:prepend>
                          <v-avatar color="primary" class="text-white">
                            {{ inquiry.created_user_id ? inquiry.created_user_id.substring(0, 1).toUpperCase() : 'U' }}
                          </v-avatar>
                        </template>
                        <v-list-item-title class="font-weight-bold mb-1">
                          {{ inquiry.created_user_id || '名無しさん' }}
                          <span class="text-caption text-grey ml-2">{{ formatDate(inquiry.created_date) }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-body-1 text-black" style="white-space: pre-wrap; opacity: 1;">
                          {{ inquiry.inquiry_content }}
                        </v-list-item-subtitle>
                        
                        <!-- 店舗からの返信 -->
                        <v-card v-if="inquiry.answer" color="grey-lighten-4" class="mt-3 pa-3 rounded-lg" variant="flat">
                          <div class="d-flex align-center justify-space-between mb-1">
                            <div class="d-flex align-center">
                              <v-icon color="success" size="small" class="mr-1">mdi-store</v-icon>
                              <span class="font-weight-bold text-success text-caption">店舗からの返信</span>
                            </div>
                            <span class="text-caption text-grey">{{ formatDate(inquiry.last_updated_date) }}</span>
                          </div>
                          <div class="text-body-2" style="white-space: pre-wrap;">{{ inquiry.answer }}</div>
                        </v-card>
                        
                        <!-- 店舗オーナー向け 返信フォーム -->
                        <div v-else-if="isStoreOwner" class="mt-3 pa-3 rounded-lg bg-grey-lighten-5 border">
                          <div class="d-flex align-center mb-2">
                            <v-icon color="primary" size="small" class="mr-1">mdi-reply</v-icon>
                            <span class="font-weight-bold text-primary text-caption">オーナーとして返信する</span>
                          </div>
                          <v-textarea
                            v-model="replyContents[inquiry.record_id]"
                            label="返信内容を入力"
                            variant="outlined"
                            rows="2"
                            hide-details="auto"
                            class="mb-2 bg-white"
                          ></v-textarea>
                          <div class="text-right">
                            <v-btn
                              color="primary"
                              size="small"
                              :loading="isSubmittingReply[inquiry.record_id]"
                              :disabled="!replyContents[inquiry.record_id] || !replyContents[inquiry.record_id].trim()"
                              @click="submitReply(inquiry.record_id)"
                            >
                              返信を送信
                            </v-btn>
                          </div>
                        </div>

                        <v-divider class="mt-4" v-if="index < sport_store.sports_store_inquiry.length - 1"></v-divider>
                      </v-list-item>
                    </v-list>
                  </div>
                  <div v-else class="text-center py-10">
                    <v-icon size="64" color="grey-lighten-2">mdi-comment-off</v-icon>
                    <p class="text-grey mt-4 text-h6 font-weight-regular">クチコミはまだありません</p>
                  </div>

                  <!-- 投稿フォーム -->
                  <v-divider class="my-4"></v-divider>
                  <div v-if="isStoreOwner" class="text-center bg-grey-lighten-4 pa-6 rounded-lg">
                    <v-icon color="grey" size="large" class="mb-2">mdi-store-alert</v-icon>
                    <p class="mb-0 text-grey-darken-1">店舗オーナーは自店舗にクチコミを投稿できません。</p>
                  </div>
                  <div v-else-if="is_logged_in">
                    <h3 class="text-h6 mb-3">クチコミを投稿する</h3>
                    <v-textarea
                      v-model="newInquiryContent"
                      label="クチコミ・質問を入力"
                      variant="outlined"
                      rows="3"
                      hide-details="auto"
                      class="mb-3"
                    ></v-textarea>
                    <v-btn
                      color="primary"
                      :loading="isSubmittingInquiry"
                      :disabled="!newInquiryContent.trim()"
                      @click="submitInquiry"
                    >
                      投稿する
                    </v-btn>
                  </div>
                  <div v-else class="text-center bg-grey-lighten-4 pa-6 rounded-lg">
                    <v-icon color="grey" size="large" class="mb-2">mdi-lock</v-icon>
                    <p class="mb-3">クチコミを投稿するにはログインが必要です</p>
                    <v-btn color="primary" variant="outlined" to="/login">ログイン画面へ</v-btn>
                  </div>
                </v-card-text>
              </v-window-item>

              <!-- 地図・アクセス タブ -->
              <v-window-item value="3">
                <div class="bg-white ma-4 rounded-lg elevation-1 overflow-hidden">
                  <iframe 
                    v-if="sport_store.address_prefecture || sport_store.store_name"
                    :src="mapEmbedUrl" 
                    width="100%" 
                    height="350" 
                    style="border:0; display: block;" 
                    allowfullscreen="" 
                    loading="lazy">
                  </iframe>

                <v-list lines="two" class="bg-transparent pt-0 pb-0">
                  <v-list-item>
                    <template v-slot:prepend>
                      <v-icon color="primary" class="mr-3">mdi-map-marker</v-icon>
                    </template>
                    <v-list-item-title class="font-weight-bold">住所</v-list-item-title>
                    <v-list-item-subtitle class="mt-2" v-if="sport_store.address_prefecture">
                      〒{{ sport_store.address_postal_code }}<br>
                      {{ sport_store.address_prefecture }}{{ sport_store.address_city_town_village }}{{ sport_store.address_street_number }}{{ sport_store.address_building_name }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="mt-2" v-else>未登録</v-list-item-subtitle>
                  </v-list-item>

                  <v-divider inset></v-divider>

                  <v-list-item>
                    <template v-slot:prepend>
                      <v-icon color="primary" class="mr-3">mdi-train</v-icon>
                    </template>
                    <v-list-item-title class="font-weight-bold">アクセス</v-list-item-title>
                    <v-list-item-subtitle class="mt-1">{{ sport_store.access || '未登録' }}</v-list-item-subtitle>
                  </v-list-item>

                  <template v-if="sport_store.map_url">
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <template v-slot:prepend>
                        <v-icon color="primary" class="mr-3">mdi-google-maps</v-icon>
                      </template>
                      <v-list-item-title class="font-weight-bold">Google Map URL</v-list-item-title>
                      <v-list-item-subtitle class="mt-1">
                        <a :href="sport_store.map_url" target="_blank" class="text-decoration-none text-primary">
                          <v-icon size="small" class="mr-1">mdi-open-in-new</v-icon>
                          {{ sport_store.map_url }}
                        </a>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>
                </v-list>
                </div>
              </v-window-item>
            </v-window>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  props: ['sportsStoreId'],
  data: () => ({
    tab: "1",
    // お店Json
    sport_store: {
      "access": null,
      "address_building_name": null,
      "address_city_town_village": null,
      "address_postal_code": null,
      "address_prefecture": null,
      "address_street_number": null,
      "appeal_point": null,
      "business_hours": null,
      "created_date": null,
      "created_user_id": null,
      "last_updated_date": null,
      "map_url": null,
      "parking_lot_availability": true,
      "phone_number": null,
      "regular_holiday": null,
      "sports_store_id": null,
      "sports_store_inquiry": [],
      "sports_store_link": [],
      "sports_store_photo": [],
      "sports_store_sports_gear": [],
      "store_name": null,
      "updated_user_id": null
    },
    // 選択済み競技リスト
    selectSportsGearValues: [],
    // 写真リスト
    uploadFileList: [],
    // リンクリスト
    linkList: [],
    masterSportList: [],
    is_favorite: false,
    is_logged_in: false,
    login_user_id: null,
    newInquiryContent: '',
    isSubmittingInquiry: false,
    replyContents: {},
    isSubmittingReply: {},
  }),
  computed: {
    isStoreOwner() {
      return this.is_logged_in && this.login_user_id && this.sport_store && this.sport_store.created_user_id === this.login_user_id;
    },
    mapEmbedUrl() {
      let queryParts = [];
      if (this.sport_store.address_postal_code) {
        queryParts.push(`〒${this.sport_store.address_postal_code}`);
      }
      let address = `${this.sport_store.address_prefecture || ''}${this.sport_store.address_city_town_village || ''}${this.sport_store.address_street_number || ''}`;
      if (address) {
        queryParts.push(address);
      }
      if (this.sport_store.store_name) {
        queryParts.push(this.sport_store.store_name);
      }
      
      let query = queryParts.join(' ');
      if (!query) return '';
      
      return `https://maps.google.co.jp/maps?output=embed&q=${encodeURIComponent(query)}&z=16`;
    }
  },
  created: function () {
    if (this.sportsStoreId != null) {
      this.getData(this.sportsStoreId)
    } else if (this.$route.params.sportsStoreId != null) {
      this.getData(this.$route.params.sportsStoreId)
    }
    
    // ログイン状態とお気に入りのチェック
    if (this.$store.getters.getToken) {
      this.is_logged_in = true;
      this.checkFavoriteStatus();
    }
    
    // 競技リスト取得
    axios.get(process.env.VUE_APP_API_URL + '/api/master_sport_list')
      .then(response => {
        if (response.status === 200) {
          this.masterSportList = response.data.master_sport_list;
        }
      })
  },
  methods: {
    getSportName(sportId) {
      const sport = this.masterSportList.find(s => s.sport_id === sportId);
      return sport ? sport.sport_name : sportId;
    },
    getData(sportsStoreId) {
      this.clrData()
      axios.get(process.env.VUE_APP_API_URL + '/sportsstore/get/' + sportsStoreId)
        .then(response => {
          this.sport_store = response.data.sport_store
          // 写真リスト
          this.sport_store.sports_store_photo.forEach(photo => {
            const fileData = {
              record_id: photo.record_id,
              name: photo.filename,
              url: photo.path
            }
            this.uploadFileList.push(fileData)
          })
          this.sport_store.sports_store_sports_gear.forEach(gear => {
            // 選択済み競技リスト
            this.selectSportsGearValues.push(gear.sport_id)
          })
          this.sport_store.sports_store_link.forEach(link => {
            this.linkList.push(link)
          })
        }).catch(err => {
          console.log(err)
        })
    },
    clrData() {
      this.sport_store = {
        "access": null,
        "address_building_name": null,
        "address_city_town_village": null,
        "address_postal_code": null,
        "address_prefecture": null,
        "address_street_number": null,
        "appeal_point": null,
        "business_hours": null,
        "created_date": null,
        "created_user_id": null,
        "last_updated_date": null,
        "map_url": null,
        "parking_lot_availability": true,
        "phone_number": null,
        "regular_holiday": null,
        "sports_store_id": null,
        "sports_store_inquiry": [],
        "sports_store_link": [],
        "sports_store_photo": [],
        "sports_store_sports_gear": [],
        "store_name": null,
        "updated_user_id": null
      }
      this.selectSportsGearValues = []
      this.linkList = []
      this.uploadFileList = []
    },
    checkFavoriteStatus() {
      let targetId = this.sportsStoreId || this.$route.params.sportsStoreId;
      axios.get(process.env.VUE_APP_API_URL + '/api/logincheck',
    {headers: {"Authorization": JSON.stringify(this.$store.getters.getToken)}}).then(response => {
      this.is_logged_in = true;
      if (response.data && response.data.user) {
        this.login_user_id = response.data.user.user_id;
      }
    }).catch(() => {
      this.is_logged_in = false;
      this.login_user_id = null;
    });
      axios.get(
        process.env.VUE_APP_API_URL + '/api/mypage_data',
        { headers: { "Authorization": JSON.stringify(this.$store.getters.getToken) } }
      ).then(response => {
        if (response.status == 200) {
          const favs = response.data.favorite_stores;
          this.is_favorite = favs.some(store => store.sports_store_id == targetId);
        }
      });
    },
    toggleFavorite() {
      let targetId = this.sportsStoreId || this.$route.params.sportsStoreId;
      axios.post(
        process.env.VUE_APP_API_URL + '/api/favorite/toggle',
        { sports_store_id: targetId },
        { headers: { "Authorization": JSON.stringify(this.$store.getters.getToken) } }
      ).then(response => {
        if (response.status == 200) {
          this.is_favorite = response.data.is_favorite;
        }
      }).catch(err => {
        console.log("お気に入り登録エラー:", err);
      });
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    },
    submitInquiry() {
      if (!this.newInquiryContent.trim()) return;
      this.isSubmittingInquiry = true;
      let targetId = this.sportsStoreId || this.$route.params.sportsStoreId;
      
      const payload = {
        sports_store_inquiry: [
          {
            inquiry_content: this.newInquiryContent.trim()
          }
        ]
      };

      axios.post(
        process.env.VUE_APP_API_URL + '/sportsstore/updateinquiry/' + targetId,
        payload,
        { headers: { "Authorization": JSON.stringify(this.$store.getters.getToken), "Content-Type": "application/json" } }
      ).then(response => {
        if (response.status == 200) {
          this.newInquiryContent = '';
          // データを再取得して表示を更新
          this.getData(targetId);
        }
      }).catch(err => {
        console.log("クチコミ投稿エラー:", err);
        alert("クチコミの投稿に失敗しました。");
      }).finally(() => {
        this.isSubmittingInquiry = false;
      });
    },
    submitReply(recordId) {
      if (!this.replyContents[recordId] || !this.replyContents[recordId].trim()) return;
      this.isSubmittingReply[recordId] = true;
      let targetId = this.sportsStoreId || this.$route.params.sportsStoreId;
      
      const payload = {
        sports_store_inquiry: [
          {
            record_id: recordId,
            answer: this.replyContents[recordId].trim()
          }
        ]
      };

      axios.post(
        process.env.VUE_APP_API_URL + '/sportsstore/updateinquiry/' + targetId,
        payload,
        { headers: { "Authorization": JSON.stringify(this.$store.getters.getToken), "Content-Type": "application/json" } }
      ).then(response => {
        if (response.status == 200) {
          this.replyContents[recordId] = '';
          // データを再取得して表示を更新
          this.getData(targetId);
        }
      }).catch(err => {
        console.log("返信投稿エラー:", err);
        alert("返信の投稿に失敗しました。");
      }).finally(() => {
        this.isSubmittingReply[recordId] = false;
      });
    }
  },
}
</script>
<style scoped>
.min-h-200 {
  min-height: 200px;
}
</style>